import CardsEvaluacion from "./CardsEvaluacion";

const EvaluacionFront = () => {
  const infoText = {
    text1: "Observar",
    text2: "- Cráneo, Clavículas",
    text3: "- Charpy",
    text4: "- Abdomen",
    text5: "- Rodillas",
    text6: "- Asimetrías no fisiológicas"}

   
  return (
    <CardsEvaluacion
      urlImage="front-card-traced.png"
      title="Vista Anterior"
      text1={infoText.text1}
      text2={infoText.text2}
      text3={infoText.text3}
      text4={infoText.text4}
      text5={infoText.text5}
      text6={infoText.text6}
      htmlFor="fileUpload1"
      idDraw="drawFront"
    />
  );
};

export default EvaluacionFront;

